export const DEFAULT_FIRESTORE_DATABASE = '(default)';
export const STAGING_FIRESTORE_DATABASE = 'staging';

export function resolveFirestoreDatabaseId(
  value = process.env.REACT_APP_FIRESTORE_DATABASE,
  nodeEnv = process.env.NODE_ENV
) {
  const id = String(value || '').trim();
  if (id && id !== DEFAULT_FIRESTORE_DATABASE) {
    return id;
  }
  if (!id && nodeEnv === 'development') {
    return STAGING_FIRESTORE_DATABASE;
  }
  return DEFAULT_FIRESTORE_DATABASE;
}

export function isNamedFirestoreDatabase(databaseId) {
  return Boolean(databaseId) && databaseId !== DEFAULT_FIRESTORE_DATABASE;
}
